// Event Bus for Vue 3
// Simple implementation to replace Vue 2's $on/$emit system

class EventBus {
  constructor() {
    this.events = {}
  }

  // Emit an event
  emit(event, data) {
    if (this.events[event]) {
      this.events[event].forEach(callback => callback(data))
    }
  }

  // Listen to an event
  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(callback)
  }

  // Remove event listener
  off(event, callback) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(cb => cb !== callback)
    }
  }

  // Remove all listeners for an event
  offAll(event) {
    delete this.events[event]
  }
}

// Create and export a single instance
export const eventBus = new EventBus()